import { mergeRoomUrl } from "./api-url.constants";
import { jsonFetch } from "@/lib/helpers";

export interface MergeRoomRequestDTO {
  targetRoomId: string;
}

export interface MergeRoomResponseDTO {
  mergedInto: string;
}

export const mergeRoom = async (
  sourceRoomId: string,
  body: MergeRoomRequestDTO
): Promise<MergeRoomResponseDTO> => {
  return jsonFetch<MergeRoomResponseDTO>(mergeRoomUrl(sourceRoomId), {
    method: "POST",
    body: JSON.stringify(body),
  });
};
